import { getVocabulary } from "components/Vocabulary";
import React from "react";
import { CustomFindingColumn } from "types/tenantConfig";

import ACMultiSelectCheckbox from "ac-components/ac-multi-select-checkbox";

import {
  customColumnsToWidgetOptions,
  toWidgetOptions,
} from "./widgetColumnUtils";

const PRODUCT_SUMMARY_COLUMN_DEFS = [
  {
    key: "name",
    getLabel: () => getVocabulary("product"),
    disabled: true,
    existing: true,
  },
  { key: "status", getLabel: () => "Status", existing: true },
  { key: "score", getLabel: () => getVocabulary("riskScore"), existing: true },
  { key: "id", getLabel: () => "Findings", existing: true },
  { key: "type", getLabel: () => "Type", existing: true },
  { key: "tags", getLabel: () => "Tags", existing: true },
  {
    key: "teamName",
    getLabel: () => getVocabulary("team", true),
    existing: true,
  },
  {
    key: "securityOwner",
    getLabel: () => getVocabulary("securityOwner", true),
    existing: true,
  },
  { key: "businessOwner", getLabel: () => getVocabulary("businessOwner") },
  {
    key: "engineeringOwner",
    getLabel: () => getVocabulary("engineeringOwner"),
  },
  { key: "supportOwner", getLabel: () => getVocabulary("supportOwner") },
  { key: "complianceOwner", getLabel: () => getVocabulary("complianceOwner") },
  {
    key: "subProductCount",
    getLabel: () => `${getVocabulary("subProduct")} Count`,
  },
];

export const PRODUCT_SUMMARY_COLUMN_KEYS = PRODUCT_SUMMARY_COLUMN_DEFS.filter(
  (i) => i.existing,
).map((d) => d.key);

export const getProductSummaryColumnsForWidgetOptions = (
  customColumns: CustomFindingColumn[] = [],
) => [
  ...toWidgetOptions(PRODUCT_SUMMARY_COLUMN_DEFS),
  ...customColumnsToWidgetOptions(customColumns),
];

export const getProductSummaryColumnsSelectionField = (
  customColumns: CustomFindingColumn[] = [],
) => {
  return {
    name: "activeColumnKeys",
    label: `${getVocabulary("product")} Summary Columns`,
    render: () => (
      <ACMultiSelectCheckbox
        options={getProductSummaryColumnsForWidgetOptions(customColumns)}
      />
    ),
  };
};
